/* globals API_ROOT */
// Polyfill for fetch()
import 'whatwg-fetch'

// Base url for endpoints
const base_url = API_ROOT

export function buildRequest(endpoint, method, body) {
	let data = new FormData()
	data.append('data',(method.toUpperCase() == 'POST' ? JSON.stringify(body) : null))
	return new Request(base_url + endpoint, {
		method: method,
		mode: 'cors',
		redirect: 'follow',
		body: data
	})
}

export function makeRequest(endpoint, method, body) {
	return fetch(buildRequest(endpoint,method,body)).then(response => response)
}

export function buildResponse(successful, data = null) {
		return {
			'successful' : successful,
			'data' : data
		}
}

export function buildError(response, reject, errorDescription) {
		return response.json().then((json = null) => reject(buildResponse(false, {
			'error' : json.message,
			'raw' : (json ? json : null)
		})))
		.catch((e) => {
			reject(buildResponse(false, {
				'error' : errorDescription,
				'raw' : e
			}))
		})
	}



// WEBPACK FOOTER //
// ./src/helpers/requestHandler.js